import { compareDesc } from 'date-fns';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';

import { ICompanyDataModel } from '../../../data-models/company.data-model';
import { roundsByIdMapAtom } from '../../../services/state/AppConfigStateJ';
import { companyMetricsAtomJ } from '../../../services/state/CompanyMetricsStateJ';
import { latestFundingsByCompanyState } from '../../CompanyProfiles/state/CompanyFundingsState';
import { roundsByCompanyIdStateJ } from '../../Finance2/state/FinanceStateJ';

export function useMergedDigestData(company: ICompanyDataModel) {
  const rounds = useAtomValue(roundsByCompanyIdStateJ(company.id));
  const latestRoundData = useMemo(
    () => [...(rounds ?? [])].sort((a, b) => compareDesc(new Date(a.roundDate), new Date(b.roundDate)))?.[0],
    [rounds]
  );
  const metrics = useAtomValue(companyMetricsAtomJ({ companyId: company.id }));
  const lastFundingsData = useAtomValue(latestFundingsByCompanyState(company.id));
  const roundsMap = useAtomValue(roundsByIdMapAtom);

  const result = { ...company };
  if (company?.companyType === 'portfolio') {
    result.lastPostMoney = metrics?.included?.[0]?.lastPostMoney || company.lastPostMoney;
    result.latestFundingRound =
      roundsMap.get(latestRoundData?.roundId ?? -1)?.name || latestRoundData?.name || '';
    result.latestFundingAmount = latestRoundData?.raiseAmount ?? null;
    result.latestLeadInvestor = latestRoundData?.leadInvestors ?? [];
    result.latestFundingDate = latestRoundData?.roundDate ?? null;
    result.raisedToDate = metrics?.included?.[0]?.raisedToDate ?? null;
  } else {
    result.lastPostMoney =
      lastFundingsData?.valuationInMillions != null ? lastFundingsData.valuationInMillions * 1_000_000 : null;
  }
  return result;
}
